<template>
  <div @click='openModal'>
    <!-- 弹框 -->
    <el-input
      :placeholder="placeholder"
      :value="name || value"
      readonly
      :disabled='view'
    ></el-input>
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '../select_org_cus_ter/select_config.vue';

export default {
  name: 'NoticeManageTableForm',
  components: {
    SelectConfig,
  },
  props: {
    value: String,
    placeholder: String,
    view: Boolean,
    parentCode: String,
    functionCode: String,
    paramsObj: Object,
    infoKey: String,
    infoCallback: Function,
  },
  data() {
    return {
      modalConfig: {}, // 弹框信息
      name: '',
    };
  },
  methods: {
    onGetSelect(val) {
      // if (this.infoCallback) {
      //   this.name = this.infoCallback(val);
      // } else {
      //   this.name = val[0][this.infoKey];
      // }

      this.$emit('setCheckInfo', val);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      list1.forEach((v1) => {
        let notRepeat = true;
        const rowData = v1;
        for (const v2 in list2) {
          if (v1[key] === list2[v2][key]) {
            notRepeat = true;
            return false;
          }
        }
        if (notRepeat) {
          list.push(rowData);
        }
        return rowData;
      });
      return list;
    },
    // 打开弹窗
    openModal() {
      const params = {
        ...this.paramsObj,
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
